import { render } from "./Import.vue?vue&type=template&id=10048b5d"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=10048b5d&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__